import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 12l6 -9l6 9l-6 9l-6 -9","key":"svg-0"}],["path",{"d":"M6 12l6 -3l6 3l-6 2l-6 -2","key":"svg-1"}]]

const IconCurrencyEthereum = createReactComponent('outline', 'currency-ethereum', 'CurrencyEthereum', __iconNode);

export default IconCurrencyEthereum;